import GetBlogAPI from "./GetBlogAPI";

const GetBlogService = async (id?: string): Promise<any> => {
  try {
    return await GetBlogAPI(id);
  } catch (error) {
    throw error;
  }
};

export default GetBlogService;
